var map = {
	"./animeQuiz.png": 534,
	"./breakOutBrick.png": 515,
	"./breakOutCube.png": 760,
	"./calculatorJS.png": 692,
	"./deleteSame.png": 402,
	"./duck.png": 778,
	"./easyPegSolitaire.png": 881,
	"./encrypt.png": 953,
	"./eye.png": 152,
	"./goldenRectangle.png": 973,
	"./hackathonvol3.png": 620,
	"./hangman.png": 573,
	"./live2d.png": 917,
	"./magicCircle.png": 975,
	"./moon.png": 246,
	"./myVideo.png": 109,
	"./numberBlock.png": 115,
	"./paike.png": 113,
	"./pixelFlagQuiz.png": 79,
	"./planeWar.png": 679,
	"./pyramidPuzzles.png": 751,
	"./quine.png": 285,
	"./sevenTangrams.png": 290,
	"./sharingan.png": 363,
	"./shootingDefense.png": 233,
	"./skyBall.png": 156,
	"./user.png": 852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 624;